<div class="tooltip-icon">
  <i class="pi pi-exclamation-circle"></i>
  <span class="tool-tip">{{ text }}</span>
</div>
